import React from "react";

export default function Phonetic(props) {
  return <span className="Phonetic opacity-75">{`${props.text} `}</span>;
}
